module.exports = __webpack_public_path__ + "img/cc.e0f0222d.png";